import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './AudienceSeatingLayoutEntryV2.html?raw';
import { AudienceSeatingLayoutsEditor } from '../../MainCatalogEditorTools';
import { MainCatalogTypes, MainCatalogs_Classes } from "../../../_loadingHelpers/MainCatalogTypes";

class AudienceSeatingLayoutEntry extends compose(_WidgetBaseSP) {
    templateString: any = template;

    editor: MdsLax<InstanceType<typeof AudienceSeatingLayoutsEditor>>;

    isToDelete: boolean = false;


    audienceSeatingEditContainer: HTMLElement;

    setEntry(isNew: boolean, entry?: MainCatalogTypes.AudienceSeatingLayoutsEditor_LoadData): void {

        this.editor = new AudienceSeatingLayoutsEditor();

        this.editor.prepareFormData(entry);
        this.editor.placeAt(this.audienceSeatingEditContainer);
        this.editor.hideSaveButton(true);
        this.editor.on("SerializeData", lang.hitch(this, this._onEditor__SerializeData));
        this.editor.on("SerializeData", lang.hitch(this, this._onEditor__SerializeData));

        this.UiModder.domClass.remove(this.editor.domNode, ["mediumTransparentBG", "secondaryOutline"]);
    }

    _onEditor__SerializeData() {
        this.emit("SerializeData");
    }

  

    //BASE
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(AudienceSeatingLayoutEntry);